import React from 'react'
import { FormattedMessage } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
}

const FallbackWrapper = styled.div`
  padding: ${rem(16)};
`

class ChatFlightErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error('[ChatFlightCarousel] Render error:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <FallbackWrapper>
          <BodyText variant="medium" colour="light-foreground-alt">
            <FormattedMessage
              id="3eLhnBxZRYhvxnfMbdHm"
              defaultMessage="Unable to display flight results."
              description="Fallback message shown when the flight search UI encounters an unexpected error"
            />
          </BodyText>
        </FallbackWrapper>
      )
    }
    return this.props.children
  }
}

export default ChatFlightErrorBoundary
